const GEO_PDF_MARKERS = /\/LGIDict|\/GEOSPATIAL|OGC:PDF|PROJCS\[|GEOGCS\[/

function readBlobAsLatin1(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      const buffer = reader.result
      resolve(new TextDecoder('latin1').decode(buffer))
    }
    reader.onerror = () => reject(reader.error)
    reader.readAsArrayBuffer(blob)
  })
}

export async function looksLikeGeoPdf(file) {
  if (!file) return false
  const headLen = Math.min(file.size, 4 * 1024 * 1024)
  const tailLen = Math.min(file.size, 512 * 1024)
  try {
    const head = await readBlobAsLatin1(file.slice(0, headLen))
    if (GEO_PDF_MARKERS.test(head)) return true
    if (file.size <= headLen) return false
    const tail = await readBlobAsLatin1(file.slice(file.size - tailLen))
    return GEO_PDF_MARKERS.test(tail)
  } catch (error) {
    return false
  }
}

export function emptyPdfGeoref() {
  return {
    is_geopdf: false,
    srs: '4326',
    min_x: '',
    min_y: '',
    max_x: '',
    max_y: '',
  }
}

export function isCompletePdfGeoref(georef) {
  if (!georef) return false
  if (georef.is_geopdf) return true
  const srs = georef.srs
  if (srs === null || srs === undefined || String(srs).trim() === '') {
    return false
  }
  const minX = Number(georef.min_x)
  const minY = Number(georef.min_y)
  const maxX = Number(georef.max_x)
  const maxY = Number(georef.max_y)
  if ([minX, minY, maxX, maxY].some((value) => Number.isNaN(value))) {
    return false
  }
  return maxX > minX && maxY > minY
}

export function parseBboxPaste(text) {
  if (text == null) return null
  const cleaned = String(text)
    .trim()
    .replace(/^[[{(]+/, '')
    .replace(/[)\]}]+$/, '')
  const parts = cleaned
    .split(/[,;\s]+/)
    .map((part) => part.trim())
    .filter(Boolean)
  if (parts.length !== 4) return null
  const nums = parts.map((part) => Number(part))
  if (nums.some((value) => Number.isNaN(value))) return null
  return {
    min_x: parts[0],
    min_y: parts[1],
    max_x: parts[2],
    max_y: parts[3],
  }
}

export function serializePdfGeorefs(georefs) {
  const payload = {}
  Object.keys(georefs || {}).forEach((name) => {
    const row = georefs[name]
    if (!row) return
    if (row.is_geopdf) {
      payload[name] = { is_geopdf: true }
      return
    }
    payload[name] = {
      srs: row.srs,
      min_x: row.min_x,
      min_y: row.min_y,
      max_x: row.max_x,
      max_y: row.max_y,
    }
  })
  return payload
}
